export const ROLES = {
  ADMIN: 'Admin',
  COMPANYADMIN: 'Company Admin',
  MANAGEMENT: 'Management',
  HR: 'HR',
  COACH :"Coach",
  EMPLOYEE: "Employee" ,
  SCIENCEOFSELF: "Science Of Self",
  SALESTRAININGCOMPANY: "Sales Training Company",
  ADHOCHR :"Adhoc HR"
};

// Define which routes each role can access
export const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: [
    'companies',
    'companies/companyview',
    'coaches',
    'coaches/view',
    'session-master',
    'assignments',
    'supported-documents',
    'quiz-master',
    'quiz-master/quizView',
    'prospectCompany',
    'prospectCompany/view',
    'scienceOfSelf',
    'scienceOfSelf/view',
    'salesTrainingCompanies',
    'salesTrainingCompanies/view',
    'adhoc-company',
    'adhoc-company/view',
    'dashboard',
    'setting',
    'learning-feedback',
  ],
  [ROLES.HR]: [
    'employee',
    'employee/view',
    'dashboard',
    "companySession","companySession/view", "setting",
    "sessions", "sessions/view", "interViewCandidate","batches","batches/view","management" , 'supported-documents',"assignments",
    "results-of-assessments"
  ],
  [ROLES.MANAGEMENT]: [
    'employee',
    'employee/view',
    'dashboard',
    "companySession","companySession/view", "setting",
    "sessions", "sessions/view", "interViewCandidate","batches","batches/view","management" , 'supported-documents',"assignments",
    "results-of-assessments"
  ],
   [ROLES.COMPANYADMIN]: [
    'employee',
    'employee/view',
    'dashboard',
    "companySession","companySession/view", "setting",
    "sessions", "sessions/view", "interViewCandidate","batches","batches/view","management" , 'supported-documents',"assignments",
    "results-of-assessments"
  ],
   [ROLES.COACH]: [
    'dashboard',
    'companies','companies/companyview',"allSessions" ,"allSessions/View", "setting"
  ],
   [ROLES.EMPLOYEE]: [
    'dashboard',
    "sessions", "sessions/view", 'supported-documents',"assignments", "setting",
    "results-of-assessments"
  ] ,
     [ROLES.SCIENCEOFSELF]: [
    'dashboard',
    "sessions", "sessions/view", 'supported-documents',"assignments", "setting",
    "results-of-assessments"
  ] ,
     [ROLES.SALESTRAININGCOMPANY]: [
    'dashboard',
    "sessions", "sessions/view", 'supported-documents',"assignments", "setting",
    "results-of-assessments"
  ] ,
  [ROLES.ADHOCHR]: [
    'dashboard',
  "interViewCandidate","interViewCandidate/view" , "setting"

  ] ,
};

// Default redirect paths for each role
export const DEFAULT_ROUTES = {
  [ROLES.ADMIN]: '/companies',
  [ROLES.HR]: '/employee',
    [ROLES.COACH]: '/dashboard',
     [ROLES.EMPLOYEE]: '/sessions',
 [ROLES.ADHOCHR]: '/interViewCandidate',
 [ROLES.COMPANYADMIN]: '/employee',
  [ROLES.MANAGEMENT]: '/employee',
   [ROLES.SCIENCEOFSELF]: '/sessions',
   [ROLES.SALESTRAININGCOMPANY]: '/sessions',
};

// Function to check if a role has permission for a route
export const hasRoutePermission = (role, route) => {
  if (!role || !ROLE_PERMISSIONS[role]) {
    return false;
  }

  // Remove leading/trailing slashes for comparison
  const cleanRoute = route.replace(/^\/+|\/+$/g, '');

  // Check exact match or parent route match
  return ROLE_PERMISSIONS[role].some(allowedRoute => {
    const cleanAllowedRoute = allowedRoute.replace(/^\/+|\/+$/g, '');
    return cleanRoute === cleanAllowedRoute ||
      cleanRoute.startsWith(cleanAllowedRoute + '/') ||
      cleanAllowedRoute.startsWith(cleanRoute + '/');
  });
};

// Function to get allowed routes for a role
export const getAllowedRoutes = (role) => {
  return ROLE_PERMISSIONS[role] || [];
};
